import usePermissions from "hooks/usePermissions";
import { summarizeQuotations, useGetQuotationConsts } from "../../helpers/ShipmentQuotesV2Helpers";
import QuotationFreightModeBadge from "./QuotationFreightModeBadge";
import QuotationTypeBadge from "./QuotationTypeBadge";
import QuotationTags from "./QuotationTags";
import QuotationOwner from "./QuotationOwner";
import QuotationCosts from "./QuotationCosts";
import QuotationSchedule from "./QuotationSchedule";
import QuotationFooter from "./QuotationFooter/QuotationFooter";
import "./QuotationCard.scss";
import QuotationError from "./QuotationError";

interface QuotationCardProps {
  quotation: any;
  hasAtLeastOneRateCardQuote?: boolean;
  quoteTags?: ReturnType<typeof summarizeQuotations>;
  trafficLightBuckets?: ReturnType<typeof useGetQuotationConsts>["trafficLightBuckets"];
  quotationCount: number;
  hideFooter?: boolean;
}

export default function QuotationCard({
  quotation,
  hasAtLeastOneRateCardQuote,
  quoteTags,
  trafficLightBuckets,
  quotationCount,
  hideFooter,
}: QuotationCardProps) {
  const { permissions } = usePermissions();
  const { user_type } = JSON.parse(permissions || "{}");
  const isProvider = user_type === "provider";

  return (
    <div className="py-xl quotation-card">
      <QuotationError quotation={quotation} />
      <div className="quotation-tags-container">
        <div className="d-flex gap-sm">
          <QuotationFreightModeBadge quotation={quotation} />

          {/* Only show quote type badge if there is at least one rate card quotation */}
          {hasAtLeastOneRateCardQuote && <QuotationTypeBadge quotation={quotation} />}
        </div>

        {quotationCount > 1 && !isProvider && (
          <div style={{ marginLeft: "auto" }}>
            <QuotationTags quotation={quotation} quoteTags={quoteTags} />
          </div>
        )}
      </div>

      <div className="mt-lg quotation-general-details-container">
        <QuotationOwner quotation={quotation} />
        <div style={{ marginLeft: "auto" }}>
          <QuotationCosts quotation={quotation} trafficLightBuckets={trafficLightBuckets} />
        </div>
      </div>

      <div className="mt-lg">
        <QuotationSchedule quotation={quotation} />
      </div>

      {!hideFooter && (
        <div className="mt-xl">
          <QuotationFooter quotation={quotation} />
        </div>
      )}
    </div>
  );
}

QuotationCard.defaultProps = {
  hasAtLeastOneRateCardQuote: false,
  quoteTags: {},
  trafficLightBuckets: undefined,
  hideFooter: false,
};
